import { render, staticRenderFns } from "./Gallery9.vue?vue&type=template&id=5226ab40&scoped=true&"
import script from "./Gallery9.vue?vue&type=script&lang=js&"
export * from "./Gallery9.vue?vue&type=script&lang=js&"
import style0 from "./Gallery9.vue?vue&type=style&index=0&id=5226ab40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5226ab40",
  null
  
)

export default component.exports